import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex items-center justify-center mt-1 w-full" }
const _hoisted_3 = { class: "mt-4 text-xs text-gray-500" }

import { computed, ref } from 'vue';
import Button from '@/components/ui/button/Button.vue';
import Input from '@/components/ui/input/Input.vue';
import ErrorForm from '@/components/auth/ErrorForm.vue';
import { submitLeadCreationRequest } from '@/http/registration';
import { useStore } from 'vuex';
import { useToast } from '@/components/ui/toast';
import Toaster from '@/components/ui/toast/Toaster.vue';
import { AUTHENTICATE } from '@/store';
import { AuthenticationError } from '@/http/api';
import PasswordInput from './PasswordInput.vue';
import { validateEmail, validatePassword } from '@/lib/formValidation';


export default /*#__PURE__*/_defineComponent({
  __name: 'LeadForm',
  emits: ['nextStep', 'TOGGLE_REGISTRATION'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const { toast } = useToast();

const name = ref<string | undefined>(undefined);
const validateName = (value?: string): boolean => /^[A-Za-zÀ-ÖØ-öø-ÿ\s][A-Za-zÀ-ÖØ-öø-ÿ\s]+$/u.test(value ?? '');
const isNameValid = computed(() => validateName(name.value) || name.value === undefined);

const email = ref<string | undefined>(undefined);
const isEmailValid = computed(() => validateEmail(email.value) || email.value === undefined);

const password = ref<string | undefined>(undefined);
const isPasswordValid = computed(() => validatePassword(password.value) || password.value === undefined);

const confirmPassword = ref<string | undefined>(undefined);
const validateConfirmPassword = (value?: string): boolean => password.value === value;
const isPasswordConfirmed = computed(() => validateConfirmPassword(confirmPassword.value) || confirmPassword.value === undefined);

const phoneNumber = ref<string | undefined>(undefined);
const validatePhoneNumber = (value?: string): boolean => {
  return (value?.replace(/[^0-9]/g, '')?.length ?? 0) >= 10;
};
const isPhoneNumberValid = computed(() => validatePhoneNumber(phoneNumber.value) || phoneNumber.value === undefined);
const getOnlyNumbers = (value?: string) => value?.replace(/[^0-9]/g, '') ?? '';

const emit = __emit;

const onSubmit = async () => {
  name.value = name.value ?? '';
  email.value = email.value ?? '';
  password.value = password.value ?? '';
  confirmPassword.value = confirmPassword.value ?? '';
  phoneNumber.value = (phoneNumber.value ?? '');

  if (!(validateName(name.value) && validateEmail(email.value) && validatePassword(password.value) && validateConfirmPassword(confirmPassword.value) && validatePhoneNumber(phoneNumber.value))) {
    return;
  }

  try {
    await submitLeadCreationRequest({
      name: name.value,
      email: email.value,
      password: password.value,
      phoneNumber: '+55' + getOnlyNumbers(phoneNumber.value),
    });
  } catch (err) {
    toast({
      variant: 'destructive',
      title: 'Não foi possível criar sua conta',
      description: 'Por favor, verifique os dados e tente novamente.',
    });
    return;
  }

  try {
    await store.dispatch(AUTHENTICATE, { email: email.value, password: password.value });
  } catch (err) {
    if (err instanceof AuthenticationError) {
      toast({
        variant: 'destructive',
        title: 'Não foi possível acessar sua conta',
        description: 'Por favor, verifique os dados e tente novamente.',
      });
      return;
    }
    toast({
      variant: 'destructive',
      title: 'Aconteceu algum erro',
      description: 'Tente novamente mais tarde, mas fique tranquilo! Sua conta foi criada!',
    });
    return;
  }

  emit('nextStep');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Input, {
        type: "text",
        placeholder: "Nome",
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ErrorForm, {
        class: _normalizeClass({ invisible: isNameValid.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Insira um nome correto ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        type: "email",
        placeholder: "E-mail",
        modelValue: email.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(ErrorForm, {
        class: _normalizeClass({ invisible: isEmailValid.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" O E-mail fornecido não parece estar correto. ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(PasswordInput, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
        placeholder: "Nova Senha"
      }, null, 8, ["modelValue"]),
      _createVNode(ErrorForm, {
        class: _normalizeClass({ invisible: isPasswordValid.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" A senha deve ter pelo menos 6 caracteres. ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(PasswordInput, {
        modelValue: confirmPassword.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
        placeholder: "Repetir Senha"
      }, null, 8, ["modelValue"]),
      _createVNode(ErrorForm, {
        class: _normalizeClass({ invisible: isPasswordConfirmed.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" As senhas inseridas não correspondem. ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Input, {
          readonly: "",
          disabled: "",
          class: "w-[3rem] text-end p-0 border-box bg-gray-100",
          type: "number",
          placeholder: "+55",
          value: "+55"
        }),
        _createVNode(Input, {
          type: "tel",
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((phoneNumber).value = $event)),
            _cache[5] || (_cache[5] = () => {
          const phoneNumberValue = getOnlyNumbers(phoneNumber.value);
          let newPhoneNumberValue = '(';

          for (let i = 0; i < phoneNumberValue?.length && i < 2; i++) {
            newPhoneNumberValue += phoneNumberValue[i];
            if (i === 1) newPhoneNumberValue += ') ';
          }

          for (let i = 2; i < phoneNumberValue?.length && i < 7; i++) {
            newPhoneNumberValue += phoneNumberValue[i];
            if (i === 6) newPhoneNumberValue += '-';
          }

          for (let i = 7; i < phoneNumberValue?.length; i++) {
            newPhoneNumberValue += phoneNumberValue[i];
          }

          if (newPhoneNumberValue == phoneNumberValue) return;
          phoneNumber.value = newPhoneNumberValue;
        })
          ],
          placeholder: "(00) 00000-0000"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(ErrorForm, {
        class: _normalizeClass({ invisible: isPhoneNumberValid.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" O número de telefone fornecido não parece estar correto. ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          class: "w-full text-white rounded-full",
          variant: "default",
          type: "submit",
          size: "sm",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cadastrar ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" Já tem uma conta? "),
        _createElementVNode("a", {
          class: "text-blue-500 cursor-pointer",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('TOGGLE_REGISTRATION')))
        }, "Logar")
      ])
    ]),
    _createVNode(Toaster)
  ], 64))
}
}

})